export default __webpack_public_path__ + "static/media/news_3.a76b0b5e.png";